import {
  REQUEST_LOGIN, REQUEST_LOGIN_SUCCESS, REQUEST_LOGIN_FAILED,
  REQUEST_GET_ME, REQUEST_GET_ME_SUCCESS, REQUEST_GET_ME_FAILED,
  REQUEST_PATCH_ME, REQUEST_PATCH_ME_SUCCESS, REQUEST_PATCH_ME_FAILED,
  LOGOUT
} from "../actions/user_actions";

const initialState = {
  id: null,
  loggedIn: false,
  is_active: false,
  requestProgress: false,
  requestFailed: false,
  first_name: '',
  last_name: '',
  surname: '',
  email: '',
  phone: '',
  discount_level: 0,
  role: '',
  perm_news: false,
  perm_system_messages: false,
  last_ship_name: '',
  last_ship_description: '',
  pre_last_ship_name: '',
  pre_last_ship_description: ''
}

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_LOGIN: {
      return {
        ...state,
        requestProgress: true,
        requestFailed: false
      }
    }
    case REQUEST_LOGIN_SUCCESS: {
      return {
        ...state,
        requestProgress: false,
        requestFailed: false,
        loggedIn: true
      }
    }
    case REQUEST_LOGIN_FAILED: {
      return {
        ...state,
        requestProgress: false,
        requestFailed: true
      }
    }
    case LOGOUT: {
      return {
        ...state,
        id: null,
        loggedIn: false,
        is_active: false,
        first_name: '',
        last_name: '',
        surname: '',
        email: '',
        phone: '',
        discount_level: 0,
        role: '',
        perm_news: false,
        perm_system_messages: false,
        last_ship_name: '',
        last_ship_description: '',
        pre_last_ship_name: '',
        pre_last_ship_description: ''
      }
    }
    case REQUEST_GET_ME: {
      return {
        ...state,
        requestProgress: true,
        requestFailed: false
      }
    }
    case REQUEST_GET_ME_SUCCESS: {
      return {
        ...state,
        requestProgress: false,
        requestFailed: false,
        id: action.id,
        loggedIn: true,
        is_active: action.is_active,
        email: action.email,
        first_name: action.first_name,
        last_name: action.last_name,
        surname: action.surname,
        phone: action.phone,
        discount_level: action.discount_level,
        role: action.role,
        perm_news: action.perm_news,
        perm_system_messages: action.perm_system_messages,
        last_ship_name: action.last_ship_name,
        last_ship_description: action.last_ship_description,
        pre_last_ship_name: action.pre_last_ship_name,
        pre_last_ship_description: action.pre_last_ship_description
      }
    }
    case REQUEST_GET_ME_FAILED: {
      return {
        ...state,
        requestProgress: false,
        requestFailed: true,
        loggedIn: false
      }
    }
    case REQUEST_PATCH_ME: {
      return {
        ...state,
        requestProgress: true,
        requestFailed: false
      }
    }
    case REQUEST_PATCH_ME_SUCCESS: {
      return {
        ...state,
        requestProgress: false,
        requestFailed: false,
        id: action.id,
        loggedIn: true,
        is_active: action.is_active,
        email: action.email,
        first_name: action.first_name,
        last_name: action.last_name,
        surname: action.surname,
        phone: action.phone,
        discount_level: action.discount_level,
        role: action.role,
        perm_news: action.perm_news,
        perm_system_messages: action.perm_system_messages,
        last_ship_name: action.last_ship_name,
        last_ship_description: action.last_ship_description,
        pre_last_ship_name: action.pre_last_ship_name,
        pre_last_ship_description: action.pre_last_ship_description
      }
    }
    case REQUEST_PATCH_ME_FAILED: {
      return {
        ...state,
        requestProgress: false,
        requestFailed: true,
      }
    }
    default: return state;
  }
}
